export default "__VITE_ASSET__EeEdmS0T__"